import 'svelte/internal/disclose-version';

Avatar[$.FILENAME] = 'src/components/Avatar.svelte';

import * as $ from 'svelte/internal/client';
import { avatarTint, initials } from "../lib/format.js";

var root = $.add_locations($.from_html(`<img class="avatar svelte-1pre9qb" alt="" referrerpolicy="no-referrer"/>`), Avatar[$.FILENAME], [[11, 2]]);
var root_1 = $.add_locations($.from_html(`<span class="avatar fallback svelte-1pre9qb" aria-hidden="true"> </span>`), Avatar[$.FILENAME], [[13, 2]]);

const $$css = {
	hash: 'svelte-1pre9qb',
	code: '\n  .avatar.svelte-1pre9qb {\n    width: var(--size);\n    height: var(--size);\n    border-radius: 50%;\n    display: grid;\n    place-items: center;\n    flex: none;\n    object-fit: cover;\n    border: 1px solid var(--line);\n  }\n  .fallback.svelte-1pre9qb {\n    background: var(--tint);\n    color: #fff;\n    font-size: calc(var(--size) * 0.38);\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    border-color: transparent;\n  }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXZhdGFyLnN2ZWx0ZSIsInNvdXJjZXMiOlsiQXZhdGFyLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0PlxuICBpbXBvcnQgeyBhdmF0YXJUaW50LCBpbml0aWFscyB9IGZyb20gXCIuLi9saWIvZm9ybWF0LmpzXCI7XG5cbiAgbGV0IHsgdXNlciA9IG51bGwsIG5hbWUgPSBudWxsLCBzaXplID0gMzYgfSA9ICRwcm9wcygpO1xuXG4gIGNvbnN0IGxhYmVsID0gJGRlcml2ZWQodXNlcj8uZGlzcGxheU5hbWUgPz8gbmFtZSA/PyBcIk5laWdoYm91clwiKTtcbiAgY29uc3Qgc3JjID0gJGRlcml2ZWQodXNlcj8uYXZhdGFyVXJsID8/IG51bGwpO1xuPC9zY3JpcHQ+XG5cbnsjaWYgc3JjfVxuICA8aW1nIGNsYXNzPVwiYXZhdGFyXCIge3NyY30gYWx0PVwiXCIgd2lkdGg9e3NpemV9IGhlaWdodD17c2l6ZX0gc3R5bGU9XCItLXNpemU6IHtzaXplfXB4XCIgcmVmZXJyZXJwb2xpY3k9XCJuby1yZWZlcnJlclwiIC8+XG57OmVsc2V9XG4gIDxzcGFuIGNsYXNzPVwiYXZhdGFyIGZhbGxiYWNrXCIgc3R5bGU9XCItLXNpemU6IHtzaXplfXB4OyAtLXRpbnQ6IHthdmF0YXJUaW50KGxhYmVsKX1cIiBhcmlhLWhpZGRlbj1cInRydWVcIj5cbiAgICB7aW5pdGlhbHMobGFiZWwpfVxuICA8L3NwYW4+XG57L2lmfVxuXG48c3R5bGU+XG4gIC5hdmF0YXIge1xuICAgIHdpZHRoOiB2YXIoLS1zaXplKTtcbiAgICBoZWlnaHQ6IHZhcigtLXNpemUpO1xuICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICBkaXNwbGF5OiBncmlkO1xuICAgIHBsYWNlLWl0ZW1zOiBjZW50ZXI7XG4gICAgZmxleDogbm9uZTtcbiAgICBvYmplY3QtZml0OiBjb3ZlcjtcbiAgICBib3JkZXI6IDFweCBzb2xpZCB2YXIoLS1saW5lKTtcbiAgfVxuICAuZmFsbGJhY2sge1xuICAgIGJhY2tncm91bmQ6IHZhcigtLXRpbnQpO1xuICAgIGNvbG9yOiAjZmZmO1xuICAgIGZvbnQtc2l6ZTogY2FsYyh2YXIoLS1zaXplKSAqIDAuMzgpO1xuICAgIGZvbnQtd2VpZ2h0OiA2MDA7XG4gICAgbGV0dGVyLXNwYWNpbmc6IDAuMDJlbTtcbiAgICBib3JkZXItY29sb3I6IHRyYW5zcGFyZW50O1xuICB9XG48L3N0eWxlPlxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFrQkEsRUFBRSxzQkFBTyxDQUFDO0FBQ1YsSUFBSSxrQkFBa0I7QUFDdEIsSUFBSSxtQkFBbUI7QUFDdkIsSUFBSSxrQkFBa0I7QUFDdEIsSUFBSSxhQUFhO0FBQ2pCLElBQUksbUJBQW1CO0FBQ3ZCLElBQUksVUFBVTtBQUNkLElBQUksaUJBQWlCO0FBQ3JCLElBQUksNkJBQTZCO0FBQ2pDO0FBQ0EsRUFBRSx3QkFBUyxDQUFDO0FBQ1osSUFBSSx1QkFBdUI7QUFDM0IsSUFBSSxXQUFXO0FBQ2YsSUFBSSxtQ0FBbUM7QUFDdkMsSUFBSSxnQkFBZ0I7QUFDcEIsSUFBSSxzQkFBc0I7QUFDMUIsSUFBSSx5QkFBeUI7QUFDN0I7In0= */'
};

export default function Avatar($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Avatar);
	$.append_styles($$anchor, $$css);

	let user = $.prop($$props, 'user', 3, null),
		name = $.prop($$props, 'name', 3, null),
		size = $.prop($$props, 'size', 3, 36);

	const label = $.tag($.derived(() => user()?.displayName ?? name() ?? "Neighbour"), 'label');
	const src = $.tag($.derived(() => user()?.avatarUrl ?? null), 'src');
	var $$exports = { ...$.legacy_api() };
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var img = root();

			$.template_effect(() => {
				$.set_attribute(img, 'src', $.get(src));
				$.set_attribute(img, 'width', size());
				$.set_attribute(img, 'height', size());
				$.set_style(img, `--size: ${size() ?? ''}px`);
			});

			$.append($$anchor, img);
		};

		var alternate = ($$anchor) => {
			var span = root_1();
			var text = $.child(span, true);

			$.reset(span);

			$.template_effect(
				($0, $1) => {
					$.set_style(span, `--size: ${size() ?? ''}px; --tint: ${$0 ?? ''}`);
					$.set_text(text, $1);
				},
				[() => avatarTint($.get(label)), () => initials($.get(label))]
			);

			$.append($$anchor, span);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(src)) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			Avatar,
			10,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}